// extracted by mini-css-extract-plugin
export default {"error-message":"FormTemplateError_error-message__y65Ps","error-message--hidden":"FormTemplateError_error-message--hidden__FVVBk","error-text":"FormTemplateError_error-text__dCt3L"};